import { render, staticRenderFns } from "./AddSetpointDialog.vue?vue&type=template&id=2f678f8c&"
import script from "./AddSetpointDialog.vue?vue&type=script&lang=ts&"
export * from "./AddSetpointDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VBtn,VCombobox})
